import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as artifactActions from '~/artifact/actions';
import paywallLightManScanner from '~/images/vignettes/image-lightman.svg';
import paywallOpsCenter from '~/images/vignettes/image-operations-center.svg';
import paywallVulnDatabase from '~/images/vignettes/image-vuln-database.svg';
type GenericCTAWithNoEmailInputProps = {
  actions: object;
  artifactState: object;
  myState: object;
  orgState: object;
  type?: string;
  paywalledContent?: any[];
  className?: string;
};
class GenericCTAWithNoEmailInput extends React.Component<GenericCTAWithNoEmailInputProps, {}> {
  constructor(props, context) {
    super(props, context);
  }
  render() {
    const { className = 'bg-color--black-dark white-dark color--white p+ font--h6' } = this.props;
    //TODO: to be utilized when checking for log in status
    // const { myState, orgState } = this.props;
    // const { isLoggedIn } = myState;
    // const { org } = orgState;
    // const { id:orgId } = org;
    // const orgAppUrl = config.APP_URL && config.APP_URL.replace('app', orgId);
    // When displaying generic paywall message
    const defaultPaywallMessageHTML = (
      <div>
        <div className="grid pb+">
          <div className="grid__item col-1-3 text--center ph">
            <h3 className="font--18 text--uppercase color--primary">Verified Security Data</h3>
            <div>
              <img src={paywallVulnDatabase} width="135" title="Vulnerability Database" />
            </div>
            <p className="font--16">
              The most accurate and complete database of public and private vulnerabilities.
            </p>
          </div>

          <div className="grid__item col-1-3 text--center ph">
            <h3 className="font--18 text--uppercase color--primary">Source Code Scanner</h3>
            <div>
              <img src={paywallLightManScanner} width="130" alt="Lightman Scanner" />
            </div>
            <p className="font--16">Identify vulnerabilities in your code.</p>
          </div>

          <div className="grid__item col-1-3 text--center ph">
            <h3 className="font--18 text--uppercase color--primary">Integrate With Ease</h3>
            <div className="pv">
              <img src={paywallOpsCenter} width="130" alt="Security Operations Center" />
            </div>
            <p className="pt- font--16">
              Integrate into your existing workflows and tools without adding friction.
            </p>
          </div>
        </div>
      </div>
    );
    return (
      <div className={`${className} position--relative`}>
        <div className="clearfix mb">
          <div className={`font--30 text--center`}>
            <span className="inline-block">Learn more about our SCA solution.</span>{' '}
            <span className="inline-block">Schedule a Demo.</span>
          </div>
        </div>

        {defaultPaywallMessageHTML}
        <div className="col-1-1 left--0 flex flex--justify-content--center">
          <a
            className="btn btn--success bo-rad--0 ph pv-"
            href="https://info.veracode.com/veracode-sca-demo.html"
          >
            SCHEDULE A DEMO
          </a>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    routing: state.routing,
    myState: state.myState,
    orgState: state.orgState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GenericCTAWithNoEmailInput);
